
import { CustomerStatus } from '@/lib/supabase/customers/types/CustomerTypes';
import { Customer } from '../types';
import { getOrganizationCustomers } from './organizationCustomers';
import { getShopCustomers } from './shopCustomers';
import { getCustomersWithStatusFilter } from './statusCustomers';
import { getCustomerById } from './singleCustomer';

/**
 * Get all customers for an organization with order statistics and shop info
 */
export const getAllCustomersByOrganization = async (
  organizationId: string,
  status?: CustomerStatus,
  shopId?: string
): Promise<Customer[]> => {
  try {
    console.log("===== FETCHING CUSTOMERS =====");
    console.log(`Organization ID: ${organizationId}`);
    console.log(`Status filter: ${status || 'none'}`);
    console.log(`Shop filter: ${shopId || 'none'}`);
    
    // Directly check if customers exist for this organization_id
    const { data: customerCheck, error: checkError } = await supabase
      .from('customers')
      .select('count')
      .eq('organization_id', organizationId);
      
    if (checkError) {
      console.error('[getAllCustomersByOrganization] Error checking customers existence:', checkError);
    } else {
      console.log(`[getAllCustomersByOrganization] Customer check found ${customerCheck.length} results`);
    }
    
    // Make sure organization ID is valid
    if (!organizationId) {
      console.error("[getAllCustomersByOrganization] No organization ID provided");
      return [];
    }
    
    // If a specific status is requested, use a filtered approach
    if (status && status !== 'all') {
      return getCustomersWithStatusFilter(organizationId, status, shopId);
    }
    
    // If no shopId filter is provided, get all customers directly
    if (!shopId) {
      return getOrganizationCustomers(organizationId);
    }
    
    // If a shop filter is provided, use the shop-based filtering
    return getShopCustomers(organizationId, shopId);
  } catch (error) {
    console.error('[getAllCustomersByOrganization] Unhandled error:', error);
    return [];
  }
};

// Re-export functions from the individual files
export { getCustomerById };
export { getCustomersWithStatusFilter };

import { supabase } from '../../client';
